
export const p0 = 0;
export const p1 = 32;
export const p2 = p1 / 2;
export const p4 = p1 / 4;
export const p8 = p1 / 8;
export const p16 = p1 / 16;
export const p32 = p1 / 32;

export const getfbitm = ({fbid, fbitems, dccitems}) => {

    const fbitm = fbitems.find(a => a.id === fbid);
    if( fbitm) {
        const gbm = dccitems && dccitems.find(el => el.id === fbitm.addr);
        return gbm && gbm.bm_states && gbm.bm_states.find( el => el.id === fbitm.port)
    }
    return undefined
}